import { createContext } from 'utils/create-context';

import { CheckoutInternalState } from './types';

export const TipAmounts = {
  PERCENT_AMOUNTS: [15, 18, 20],
  DOLLAR_AMOUNTS: [2, 3, 4],
  PERCENT_DEFAULT: 18,
  DOLLAR_DEFAULT: 3,
  STYLE_THRESHOLD: 1500,
  MAX_AMOUNT: 5000,
};

const initialState: CheckoutInternalState = {
  tipIsLocked: false,
  tipAmount: 0,
  tipSelection: {
    percentAmount: TipAmounts.PERCENT_DEFAULT,
    dollarAmount: TipAmounts.DOLLAR_DEFAULT,
    otherAmount: undefined,
    isOtherSelected: false,
  },
  tipLoading: false,
  totals: null,
  errorModalOpen: false,
  isSubmittingOrder: false,
  wasCommitOrderCalled: false,
  isBuildingCommitOrderPayload: false,
  isPaymentRedirectPending: false,
  serverOrder: null,
  isOrderLoading: false,
  isRepricedOrderLoading: false,
  vehicleDescription: { value: '', hasError: false },
};

const [CheckoutProvider, useCheckoutState] = createContext('Checkout', initialState);

export { CheckoutProvider, useCheckoutState };
